import { Grid, TextField, Typography } from "@mui/material";
import { Controller } from "react-hook-form";
import { Vocabulary } from "../../Utils/Vocabulary";
import SpecialDivider from "../SpecialDivider";
import { Fragment } from "react/jsx-runtime";
import Address from "./Address";
import { GreenSwitch } from "../../Utils/Utils";

interface LocationProps {
  register: any;
  control: any;
  index: number;
  formState: any;
  watch: any;
  getValues: any;
  title: string;
}

export default function Location({
  register,
  control,
  index,
  watch,
  getValues,
  title,
}: LocationProps) {
  return (
    <Fragment>
      {/* Location Type */}
      {watch("isLegalPerson") === true && (
        <Grid xs={12} sm={12} md={6} item style={{ textAlign: "start" }}>
          <Typography>{Vocabulary.isWorkingPoint}</Typography>
          <Controller
            name={`locations[${index}].isWorkingPoint`}
            control={control}
            defaultValue={true}
            render={({ field: { value, onChange, ref } }) => (
              <GreenSwitch onChange={onChange} checked={value} inputRef={ref} />
            )}
          />
        </Grid>
      )}
      {/* ///////////////////////////////////////////////////////////////////////////Address */}
      <Address
        register={register}
        index={index}
        control={control}
        getValues={getValues}
        title={title}
        isArray={true}
      />

      {/* ///////////////////////////////////////////////////////////////////////////ALTE INFORMATII */}

      <Grid item xs={12} sm={12} md={12}>
        <SpecialDivider title={Vocabulary.otherInfos} />
      </Grid>

      <Grid item xs={12} sm={12} md={6}>
        <TextField
          {...register(`locations[${index}].bank`)}
          name={`locations[${index}].bank`}
          id="bank"
          label={Vocabulary.bank}
          fullWidth
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <TextField
          {...register(`locations[${index}].iban`)}
          name={`locations[${index}].iban`}
          id="iban"
          label={Vocabulary.iban}
          fullWidth
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12}>
        <TextField
          {...register(`locations[${index}].observations`)}
          name={`locations[${index}].observations`}
          id="observations"
          label={Vocabulary.observations}
          fullWidth
          //multiline
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      {/* ///////////////////////////////////////////////////////////////////////////ALTE INFORMATII */}
      {watch("isLegalPerson") && (
        <>
          <Grid item xs={12} sm={12} md={12}>
            <SpecialDivider title={Vocabulary.contactPerson} />
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <TextField
              {...register(`locations[${index}].contactPerson.firstName`)}
              name={`locations[${index}].contactPerson.firstName`}
              id="firstName"
              label={Vocabulary.firstName}
              fullWidth
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <TextField
              {...register(`locations[${index}].contactPerson.lastName`)}
              name={`locations[${index}].contactPerson.lastName`}
              id="lastName"
              label={Vocabulary.lastName}
              fullWidth
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <TextField
              {...register(`locations[${index}].contactPerson.email`)}
              name={`locations[${index}].contactPerson.email`}
              id="email"
              label={Vocabulary.email}
              fullWidth
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <TextField
              {...register(`locations[${index}].contactPerson.phone`)}
              name={`locations[${index}].contactPerson.phone`}
              id="phone"
              label={Vocabulary.phone}
              fullWidth
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </>
      )}
      {/* ///////////////////////////////////////////////////////////////////////////DETALII */}
      <Grid item xs={12} sm={12} md={12}>
        <SpecialDivider
          title={`${Vocabulary.settings} ${Vocabulary.client.toLowerCase()}`}
        />
      </Grid>
      <Grid xs={12} sm={12} md={6} item style={{ textAlign: "start" }}>
        <Typography>{Vocabulary.shouldClientReceiveEmail}</Typography>
        <Controller
          name={`locations[${index}].receiveEmails`}
          control={control}
          defaultValue={true}
          render={({ field: { value, onChange, ref } }) => (
            <GreenSwitch
              onChange={onChange}
              checked={value}
              inputRef={ref}
              color="default"
            />
          )}
        />
      </Grid>
    </Fragment>
  );
}
